export default __webpack_public_path__ + "static/media/marketing.fa900bf4.png";